import { isNil } from 'lodash';
import { useState } from 'react';

type CopiedValue = string | null;
type CopyFn = (text: string) => Promise<void>;

export function useCopyToClipboard(): [CopiedValue, CopyFn] {
  const [copiedText, setCopiedText] = useState<CopiedValue>(null);

  const copy: CopyFn = async (text) => {
    try {
      if (isNil(navigator?.clipboard)) {
        throw new Error('Clipboard not supported');
      }

      await navigator.clipboard.writeText(text);
      setCopiedText(text);
    } catch (error) {
      console.warn('Copy failed', error);
      setCopiedText(null);
      throw error;
    }
  };

  return [copiedText, copy];
}
